import { useQueryClient } from "@tanstack/react-query";
import TwoFactorEnrollment from "@/components/TwoFactorEnrollment";

/**
 * Forced enrollment screen — mounted by the route-level guard when the user
 * has `mustEnroll2fa = true` in their session. Cannot be cancelled; the dialog
 * blocks ESC + outside click. On successful enrollment, refetches the auth
 * user so the guard clears and the app proceeds to the dashboard.
 */
export default function ForceEnroll2FA() {
  const queryClient = useQueryClient();
  return (
    <TwoFactorEnrollment
      open={true}
      onOpenChange={() => {
        /* no-op — forced flow */
      }}
      forced
      onComplete={() => {
        queryClient.invalidateQueries({ queryKey: ["/api/auth/user"] });
        // Reload to make sure the rest of the app picks up the fresh session.
        window.location.reload();
      }}
    />
  );
}
